/**
 * Opening the group `@` picker re-reads the group's members, because some changes to WHO can be asked publish no
 * live row at all (a member adding their Maestro is one), so a picker fed only by live rows misses them until the
 * chat is reopened. At most once per `MENTION_PANEL_REFRESH_MS` per group, so a picker opened again and again is
 * free. iOS `GroupChat.refreshesMembersOnMentionOpen`, Android `GroupAdmin.refreshesMembersOnMentionOpen`.
 *
 * Import-free, so its test never loads the app's dependency graph.
 */
export const MENTION_PANEL_REFRESH_MS = 10_000;

export function shouldRefreshOnMentionOpen(lastRefreshMs: number | undefined, now: number): boolean {
  return lastRefreshMs === undefined || now - lastRefreshMs >= MENTION_PANEL_REFRESH_MS;
}

/** When each group's picker last re-read its members, for the session. */
const lastRefresh = new Map<string, number>();

/** The picker OPENED in `conversationId` at `now`: whether to re-read its members (and, if so, records it). */
export function claimMentionOpenRefresh(conversationId: string, now: number, seen: Map<string, number> = lastRefresh): boolean {
  if (!conversationId || !shouldRefreshOnMentionOpen(seen.get(conversationId), now)) return false;
  seen.set(conversationId, now);
  return true;
}
